import React from 'react';
import classNames from 'clsx';

import styles from './CustomInjectionBlock.module.scss';

type Props = {
  id: string;
  className?: string;
  children?: React.ReactNode;
};

function CustomInjectionBlock({ id, className = '', children }: Props) {
  return (
    <div id={id} className={classNames(styles.Block, className)}>
      {children}
    </div>
  );
}

export default CustomInjectionBlock;
